import { createFileRoute } from "@tanstack/react-router";

import TodosDuplicates from "@/features/todos/todos-duplicates";

export const Route = createFileRoute(
  "/_authenticated/$company/buchhaltung/eingang/duplicates",
)({
  component: PayableDuplicatesPage,
  staticData: {
    breadcrumb: ["todos.payable.title"],
  },
});

function PayableDuplicatesPage() {
  return <TodosDuplicates type="payable" />;
}
